(() => {
  const rotationDelay = 4600;

  const init = () => {
    const announcement = document.querySelector('[data-sk-announcement]');
    const message = announcement?.querySelector('[data-sk-announcement-message]');
    const pause = announcement?.querySelector('[data-sk-announcement-pause]');
    if (!announcement || !message || announcement.dataset.skAnnouncementReady) return;

    announcement.dataset.skAnnouncementReady = 'true';

    // Messages and labels come from the locale files through the section's data attributes.
    let messages = [];
    try { messages = JSON.parse(announcement.dataset.messages || '[]').filter(Boolean); } catch {}
    if (!messages.length) messages = [message.textContent.trim()];

    let activeMessage = 0;
    let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let visible = true;
    // Rotation also holds while a pointer rests on the bar or keyboard focus is inside it.
    let hovering = false;
    let focused = false;
    let rotateTimer = null;

    const showMessage = (index, animate = true) => {
      const nextIndex = (index + messages.length) % messages.length;
      const nextMessage = messages[nextIndex];
      if (nextMessage === message.textContent) return;
      activeMessage = nextIndex;

      if (!animate || typeof message.animate !== 'function') {
        message.textContent = nextMessage;
        return;
      }

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const exitAnimation = message.animate(
        reduceMotion
          ? [{ opacity: 1 }, { opacity: 0.55 }]
          : [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-8px)' }],
        { duration: reduceMotion ? 100 : 160, easing: 'cubic-bezier(0.7, 0, 0.84, 0)' }
      );
      exitAnimation.onfinish = () => {
        exitAnimation.cancel();
        message.textContent = nextMessage;
        message.animate(
          reduceMotion
            ? [{ opacity: 0.55 }, { opacity: 1 }]
            : [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: reduceMotion ? 140 : 300, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
        );
      };
    };

    const syncPause = () => {
      if (!pause) return;
      pause.setAttribute('aria-label', (paused ? announcement.dataset.resumeLabel : announcement.dataset.pauseLabel) || pause.getAttribute('aria-label'));
      pause.setAttribute('aria-pressed', String(paused));
      announcement.classList.toggle('sk-announcement--paused', paused);
    };

    const syncRotation = () => {
      window.clearInterval(rotateTimer);
      rotateTimer = null;
      if (paused || hovering || focused || !visible || messages.length < 2 || document.visibilityState !== 'visible') return;
      rotateTimer = window.setInterval(() => showMessage(activeMessage + 1), rotationDelay);
    };

    pause?.addEventListener('click', () => {
      paused = !paused;
      syncPause();
      syncRotation();
    });
    announcement.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; syncRotation(); } });
    announcement.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovering = false; syncRotation(); } });
    announcement.addEventListener('focusin', () => { focused = true; syncRotation(); });
    announcement.addEventListener('focusout', event => {
      if (announcement.contains(event.relatedTarget)) return;
      focused = false;
      syncRotation();
    });
    document.addEventListener('visibilitychange', syncRotation);

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting && entry.intersectionRatio > 0;
        syncRotation();
      }, { threshold: 0.01 });
      visibilityObserver.observe(announcement);
    }

    showMessage(0, false);
    syncPause();
    syncRotation();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
